export const sortArrayByAttribute = (
  array: any[],
  attribute: string,
  asc: boolean = true
) => {
  return array.sort((a, b) => {
    if (asc) {
      return a[attribute] > b[attribute] ? 1 : -1;
    }
    return a[attribute] < b[attribute] ? 1 : -1;
  });
};
